import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';

type Props = {
    onPrimaryCtaClick: () => void;
    onSecondaryCtaClick: () => void;
};

export function EmptyState(props: Props) {
    return (
        <EmptyStateLarge
            title='Engage visitors instantly with page based automations'
            subtitle='Automatically trigger personalized actions when identified visitors land on key pages of your site'
            detailTextBullets={[
                'Automate follow-ups based on page visits',
                'Convert high-intent traffic into leads with timely relevant actions',
                'Respond in real time when visitors show interest in your most important pages',
            ]}
            cta={
                <Button variant='primary' size='big' onClick={props.onPrimaryCtaClick}>
                    Create an automation
                </Button>
            }
            secondaryCta={
                <Button variant='text-secondary' size='big' onClick={props.onSecondaryCtaClick}>
                    Show me how to make my first automation
                </Button>
            }
            icon={<Illustration src='marketing-automations' width={333} />}
        />
    );
}
